export default __webpack_public_path__ + "static/awards-hero-5c59f15886fd3cf93ef9052f26a90f61.jpg";